import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=01a8f8fb&scoped=true"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditor.vue?vue&type=style&index=0&id=01a8f8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8f8fb",
  null
  
)

export default component.exports